import { ValueType } from 'rsuite/esm/Checkbox';
import { appNetworkManager, authNetworkManager } from './network-manager';
import { AdminConsultantRegisterModel } from '../models/admin';

export const putAcceptConsultant = (accept: ValueType, username: string, whyReject: string) =>
  appNetworkManager.put(`/consregreq`, {
    Status: accept,
    Username: username,
    Description: whyReject
  });
export const getConsultantsRequests = () => appNetworkManager.get(`/consregreqs`);
// todo: backend
export const getConsultantRequest = (username: string) =>
  appNetworkManager.get(`/consregreqone?Username=${username}`);

export const getAdminConsultantsRegisters = () => appNetworkManager.get(`/consultants`);

export const getAdminConsultantRegister = (username: string) =>
  appNetworkManager.get(`/consultant?Username=${username}`);

export const postAdminConsultantRegister = (payload: AdminConsultantRegisterModel) =>
  appNetworkManager.post(`/consultant`, payload);

export const putAdminConsultantRegister = (payload: AdminConsultantRegisterModel) => {
  // const { Username, ...rest } = payload;
  return appNetworkManager.put(`/consultant`, payload);
};

export const postAdminLoginWithPassword = (username: string, password: string) =>
  authNetworkManager.post(`/admin/loginwp`, { Username: username, Password: password });
